(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('simpleProductSelectorConfirmLabel', simpleProductSelectorConfirmLabel);

    function simpleProductSelectorConfirmLabel(lodash) {
        return {
            scope: {
                options: '=',
                selectedValue: '=',
                labelKey: '@',
            },
            templateUrl: 'common/app/components/product-selector/simple-product-selector-confirm-label',
            link: function(scope) {
                scope.sps = {
                    label: '',
                };
                scope.$watch('selectedValue', function() {
                    if (scope.selectedValue) {
                        var selectedProduct = lodash.find(scope.options.products, { id: scope.selectedValue });
                        scope.sps.label = lodash.get(selectedProduct, 'labels.' + scope.labelKey, '');
                    }
                })
            }
        };
    }
})();